import { RouteInterface } from '@/src/common/enums/routes'
import { CardBenefitsTab } from './tab'

export const Routes = {
  Benefits: {
    route: `/main/(tabs)/${CardBenefitsTab['card-benefits'].name}/benefits`,
    name: CardBenefitsTab['card-benefits'].name,
    availableForDeepLinking: true,
    aliases: [`/main/${CardBenefitsTab['card-benefits'].name}`],
  },
  Benefit: {
    route: `/main/(tabs)/${CardBenefitsTab['card-benefits'].name}/benefit`,
    name: `${CardBenefitsTab['card-benefits'].name} - Benefit`,
    availableForDeepLinking: true,
    aliases: [`/main/${CardBenefitsTab['card-benefits'].name}/benefit`],
  },
  MyLowesRewards: {
    route: `/main/(tabs)/${CardBenefitsTab['card-benefits'].name}/my-lowes-rewards`,
    name: `${CardBenefitsTab['card-benefits'].name} - My Lowes Rewards`,
    availableForDeepLinking: true,
    aliases: [`/main/${CardBenefitsTab['card-benefits'].name}/my-lowes-rewards`],
  },
  ReferralBonusOffer: {
    route: `/main/(tabs)/${CardBenefitsTab['card-benefits'].name}/referral-bonus-offer`,
    name: `${CardBenefitsTab['card-benefits'].name} - Referral Bonus Offer`,
    availableForDeepLinking: true,
    aliases: [`/main/${CardBenefitsTab['card-benefits'].name}/referral-bonus-offer`],
  },
  InstacartEnrollment: {
    route: `/main/(tabs)/${CardBenefitsTab['card-benefits'].name}/instacart-enrollment`,
    name: `${CardBenefitsTab['card-benefits'].name} - Instacart Enrollment`,
    availableForDeepLinking: true,
    aliases: [`/main/${CardBenefitsTab['card-benefits'].name}/instacart-enrollment`],
  },
} as const satisfies Record<string, RouteInterface>

export default Routes
